import { FieldErrors, FieldValues } from "react-hook-form/dist/types";

const getErrorText = (errors: FieldErrors<FieldValues>, field: string, frontErrorText?: string) =>
  field === null
    ? frontErrorText
    : (errors?.[field]?.message as string | undefined) || frontErrorText;

export default getErrorText;
